import styled from 'styled-components';
import Tab from 'react-bootstrap/Tab';

export const BSTab = styled(Tab)``;
